<template>
  <div class="case">
    <img
      src="../assets/img/home1.png"
      alt
      style="width: 100%; height: 300px"
    />
    <div class="case-section">
      <div class="case-section-content">
        <img src="../assets/img/b1.jpg"  style="border-radius: 10px;margin-top: 10px;"/>
        <img src="../assets/img/b2.jpg" style="margin-left: 28px;border-radius: 10px;" />
        <img src="../assets/img/b3.jpg" style="margin-left: 28px;border-radius: 10px;" />
        <img src="../assets/img/b4.jpg" style="margin-left: 28px;border-radius: 10px;" />
        <img src="../assets/img/b5.jpg" style="margin-left: 28px;border-radius: 10px;" />

        <el-row style="margin-top: 20px">
          <el-col :span="12"
            ><div
              class="grid-content bg-purple"
              style="
                background-color: #1476d1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 40px;
                margin-right: 15px;
                border-radius: 5px;
              "
            >
              <h4 style="color: white">通知公告</h4>
            </div>
            <ul
              style="
                background-color: whitesmoke;
                margin-right: 15px;
                margin-top: 10px;
                padding: 20px 15px;
                border-radius: 8px;
                padding-bottom: 5px;
              "
            >
              <li
                v-for="(p, index) of adverList"
                :key="index"
                style="margin-bottom: 15px; list-style: none"
              >
                <router-link
                  class="custom-link"
                  :to="{ name: 'adversdetails', params: { id: p.id } }"
                >
                  <span class="bullet">·</span>
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="p.title"
                    placement="bottom-end"
                  >
                    <span class="title">{{ p.title }}</span>
                  </el-tooltip>

                  <p class="date">{{ formatDate(p.createTime) }}</p>
                </router-link>
              </li>
            </ul>
          </el-col>
          <el-col :span="12"
            ><div
              class="grid-content bg-purple-light"
              style="
                background-color: #1476d1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 40px;
                margin-left: 15px;
                border-radius: 5px;
              "
            >
              <h4 style="color: white">政策法规</h4>
            </div>
            <ul
              style="
                background-color: whitesmoke;
                margin-left: 15px;
                margin-top: 10px;
                padding: 20px 15px;
                border-radius: 8px;
                padding-bottom: 5px;
              "
            >
              <li
                v-for="(p, index) of policyList"
                :key="index"
                style="margin-bottom: 15px; list-style: none"
              >
                <router-link
                  class="custom-link"
                  :to="{ name: 'policydetails', params: { id: p.id } }"
                >
                  <span class="bullet">·</span>
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="p.title"
                    placement="bottom-end"
                  >
                    <span class="title">{{ p.title }}</span>
                  </el-tooltip>
                  <p class="date">{{ formatDate(p.createTime) }}</p>
                </router-link>
              </li>
            </ul>
          </el-col>
        </el-row>
        <h2
          style="
            display: flex;
            justify-content: center;
            margin: 20px 0px;
            color: #1476d1;
          "
        >
          公益课程
        </h2>
        <hr />

        <ul class="couruse_list">
          <router-link
            v-for="(p, index) of PublicClassList"
            :key="index"
            style="text-decoration: none; color: black"
            :to="{
              name: 'classdetails',
              params: { id: p.id },
            }"
            target="_blank"
          >
            <li>
              <div>
                <img :src="p.img" width="300px" />
                <div>{{ p.title }}</div>
              </div>
            </li>
          </router-link>
        </ul>
        <h2
          style="
            display: flex;
            justify-content: center;
            margin: 10px 0px;
            color: #1476d1;
          "
        >
          友情链接
        </h2>
        <hr />
        <span class="firend-container">
          <a href="https://www.chinacdc.cn/" target="_blank">
            <img
              src="../assets/img/china_health.png"
              alt="中国疾病预防控制中心"
          /></a>

          <a href="http://www.hncdc.com.cn/" target="_blank">
            <img src="../assets/img/hn.gif" alt="河南省疾病预防控制中心"
          /></a>

          <a href="http://www.hnzfy.com/" target="_blank">
            <img src="../assets/img/hospital.png" alt="河南省职业病医院"
          /></a>
          
          <a href="http://wjw.jiaozuo.gov.cn/" target="_blank">
            <img src="../assets/img/jz_health.png" alt="焦作市卫生健康委员会"
          /></a>

          <a href="http://www.jiaozuocdc.com/" target="_blank">
            <img
              src="../assets/img/jz_disease.png"
              alt="焦作市疾病预防控制中心"
          /></a>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      adverList: [], //通知公告列表
      policyList: [], //政策法规列表
      PublicClassList: [], //公益课堂列表
    };
  },
  mounted() {
    this.loadAdversData();
    this.loadPolicyData();
    this.loadPublicClassData();
  },
  methods: {
    loadAdversData() {
      //type类型(1通知公告，2政策法规)
      this.$http
        .get(`api/website/resource/webGetList?type=1&num=6`)
        .then((response) => {
          this.adverList = response.data.data;
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
    loadPolicyData() {
      this.$http
        .get(`api/website/resource/webGetList?type=2&num=6`)
        .then((response) => {
          this.policyList = response.data.data;
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
    //加载公益课堂
    loadPublicClassData() {
      this.$http
        .get(`api/website/resource/webGetList?type=3&num=4`)
        .then((response) => {
          this.PublicClassList = response.data.data;
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
    formatDate(dateString) {
      const date = new Date(dateString); // 将字符串转为 Date 对象
      const year = date.getFullYear(); // 获取年份
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 获取月份，注意 JavaScript 中月份从 0 开始，需要加 1
      const day = String(date.getDate()).padStart(2, "0"); // 获取日期

      return `${year}-${month}-${day}`; // 格式化为 'YYYY-MM-DD'
    },
  },
};
</script>

 <style lang="scss" scoped>
.custom-link {
  color: black;
  text-decoration: none;
}

.custom-link:hover {
  color: #1476d1; /* 鼠标悬浮时改变文字颜色 */
}

.custom-link .bullet {
  font-weight: 800;
}

.custom-link .title {
  margin-left: 5px;
  max-width: 480px; /* 设置最大宽度来控制省略效果的触发点 */
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden; /* 超出的内容隐藏 */
  text-overflow: ellipsis; /* 使用省略号表示超出的部分 */
  display: inline-block; /* 确保它不会与其他元素发生布局问题 */
}

.custom-link .date {
  text-align: right;
  margin-top: -10px;
}
.firend-container {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between;
  margin-top: 30px;
  height: 80px;
}

.firend-container img {
  width: 200px; /* 设置图片的宽度 */
  height: auto; /* 自动调整高度，保持图片比例 */
}
.couruse_list {
  display: flex;
  justify-content: space-between;
  list-style: none;
  li {
    margin-top: 20px;
  }
}
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 800px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>